import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { H4, P } from "../../atoms/Texts";
import { DarkFormField, DarkTextArea } from "../../atoms/Inputs";
import { PrimaryButton } from "../../atoms/Buttons";

export const UpdateScheduleFormOne = ({
  fields,
  updateFields,
  _case,
  closeModal,
}) => {
  const formCtx = useFormContext();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = formCtx;

  useEffect(() => {
    if (fields) {
      reset({
        title: fields.title,
        location: fields.location,
        locationDetails: fields.locationDetails,
      });
    }
  }, [fields, reset]);

  const onSubmit = (data) => {
    updateFields(data);
  };

  return (
    <div className="pb-20">
      <form className="w-2/3 mx-auto" onSubmit={handleSubmit(onSubmit)}>
        <H4
          fontSize="20px"
          fontFamily="regular"
          color="#22202D"
          className="text-center mb-8"
        >
          Reschedule your meeting with {_case?.referral?.user?.firstName}
        </H4>
        <div className="">
          <DarkFormField
            type="text"
            id="title"
            name="title"
            {...register("title", {
              required: "Title is required",
            })}
            placeholder="Give it a name"
            label="Title"
            containerClass="flex-grow"
          />
          <ErrorMessage
            errors={errors}
            name="title"
            as={<P fontSize="12px" className="-mt-2 mb-4 text-red-400 text-sm" />}
          />
        </div>
        <div className="">
          <DarkFormField
            type="text"
            id="location"
            name="location"
            {...register("location", {
              required: "Location is required",
            })}
            placeholder="Where will the meeting hold?"
            label="Location"
            containerClass="flex-grow"
          />
          <ErrorMessage
            errors={errors}
            name="location"
            as={<P fontSize="12px" className="-mt-2 mb-4 text-red-400 text-sm" />}
          />
        </div>
        <div className="">
          <DarkTextArea
            type="text"
            id="locationDetails"
            name="locationDetails"
            rows="3"
            {...register("locationDetails")}
            placeholder="Meeting links, agenda, etc."
            label="Meeting"
            containerClass="flex-grow"
          />
        </div>
        <div className="flex items-center mt-8">
          <PrimaryButton.Light
            type="button"
            className="flex-shrink-0 mr-4"
            onClick={closeModal}
          >
            Cancel
          </PrimaryButton.Light>
          <PrimaryButton className="flex-grow">Next</PrimaryButton>
        </div>
      </form>
    </div>
  );
};
